import { Box, Button, ColorOptions, Icon, ModalDialogNew, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useInterval } from '@jfs/utils'
import { useIsFocused } from '@react-navigation/native'
import { useCallback, useEffect, useRef, useState } from 'react'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import EmptyView from '../../comps/EmptyView'
import { DateRangeSelector } from '../../comps/Filters/DateRangeSelector'
import { SvgImage } from '../../comps/SvgImage'
import { receivedDateRange } from '../../data/static/data'
import { tableItemStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { getString } from '../../util/languageStrings'
import {
  dateFormatter,
  DateFormatTypes,
  getCommaFormatedVal,
  getHHMMSS,
  getMonthName,
  roundOfToTwoDigits,
  toLateNight
} from '../../util/util'
import { Platform } from 'react-native'

export const HOME = 'HOME'
export const PAYMENTS = 'PAYMENTS'

export const ReceivedTransactionStats = ({ screenName = 'HOME', fetchTxn, fetchTxnPollingHandlerState }: any) => {
  const {
    mid,
    fetchStats,
    selectedDateInfo,
    updateSelectedDateInfo,
    setNewDate,
    successfulTxnsAmt,
    selectedAppLanguage,
  } = useStores((store) => ({
    mid: store.user.selectedMid,
    fetchStats: store.settings.metaData.fetchStatsV3,
    selectedDateInfo: store.transactions.selectedDateInfo,
    updateSelectedDateInfo: store.transactions.updateSelectedDateInfo,
    setNewDate: store.settings.metaData.updateDates,
    successfulTxnsAmt: store.settings.metaData.successfulTxnsAmt,
    selectedAppLanguage: store.settings.config.selectedAppLanguage,
  }))

  const abortControllerRef = useRef<AbortController>()
  const [showModal, setShowModal] = useState(false)
  const [isFetchingStats, setFetchingStats] = useState(false)
  const [disableBtn, setDisableBtn] = useState(false)
  const [statsDate, setStatsDate]: any = useState({})

  const [fetchStatsApi, { state: fetchStatsState }] = useLazyApiData(fetchStats)
  const [fetchStatsApiPoll, { state: reqPoolState }] = useLazyApiData(fetchStats)

  useEffect(() => {
    setStatsDate(selectedDateInfo)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (fetchStatsState === 'fulfilled' || fetchStatsState === 'rejected') {
      setShowModal(false)
      setFetchingStats(false)
    } else if (fetchStatsState === 'pending') {
      setFetchingStats(true)
    }
  }, [fetchStatsState])

  useEffect(() => {
    if (mid) {
      hitStatsApi()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mid, screenName])

  const focused = useIsFocused()

  // useInterval(() => {
  //   if (focused) {
  //     if (screenName === HOME && fetchTxnPollingHandlerState !== 'pending') {
  //       hitTnxApi()
  //     }
  //     // if fetch api is pending don't call poll API
  //     if (!isFetchingStats && !showModal && reqPoolState !== 'pending') {
  //       const isToday = selectedDateInfo.dateLabel === 'Today'
  //       abortControllerRef?.current?.abort()
  //       abortControllerRef.current = new AbortController()
  //       fetchStatsApiPoll(
  //         mid,
  //         'transactions',
  //         selectedDateInfo,
  //         isToday,
  //         undefined,
  //         undefined,
  //         false,
  //         abortControllerRef.current,
  //       )
  //     }
  //   }
  // }, 5000)

  const getTodayValue = (): Date => {
    const today = new Date(Date.now())
    return new Date(today.setHours(0, 0, 0, 0))
  }

  const hitStatsApi = useCallback(() => {
    const fromDate = selectedDateInfo?.fromDate ?? getTodayValue()

    abortControllerRef?.current?.abort()
    abortControllerRef.current = new AbortController()
    fetchStatsApi(
      mid,
      'transactions',
      selectedDateInfo,
      selectedDateInfo.dateLabel === 'Today',
      undefined,
      undefined,
      false,
      abortControllerRef.current,
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchStatsApi, mid])

  const formatCurrency = (amount: any) => {
    const totalTransaction = amount && !isNaN(amount) ? parseFloat(amount).toFixed(2) : 0
    return isNaN(Number(totalTransaction)) ? '0' : getCommaFormatedVal(Number(totalTransaction), false)
  }

  const hitTnxApi = useCallback(() => {
    const today = new Date(Date.now())
    const currentDate = dateFormatter(today, DateFormatTypes.YYYYMMDD)
    fetchTxn?.(
      1,
      10,
      tableItemStrings.transactionDesc,
      `${currentDate}${tableItemStrings.startTime}`,
      `${currentDate}${getHHMMSS(today)}`,
      mid,
      'JSON',
      ...Array(8).fill(undefined),
      'Home',
      undefined,
      undefined,
      undefined,
      true,
    )
  }, [fetchTxn, mid])

  const onRefresh = () => {
    if (screenName === HOME) {
      hitTnxApi()
    }
    const isToday = selectedDateInfo?.dateLabel === 'Today'
    abortControllerRef?.current?.abort()
    abortControllerRef.current = new AbortController()
    fetchStatsApi(
      mid,
      'transactions',
      selectedDateInfo,
      isToday,
      undefined,
      undefined,
      false,
      abortControllerRef.current,
    )
  }

  const handlePress = (date: any) => {
    let toDate = new Date(date?.toDate)
    if (date?.dateLabel === 'Custom Range' && date?.toDate) {
      toDate = new Date(toLateNight(toDate))
    }
    const disableApplyBtn = invalidDate(date)
    setDisableBtn(disableApplyBtn)
    setStatsDate({
      ...date,
      fromDate: new Date(date.fromDate),
      toDate: toDate,
    })
  }

  const handleClear = () => {
    // updateSelectedDateInfo('')
    setShowModal(false)
    // setDateObj('')
    // setDateRangeModalVisible(false)
    setDisableBtn(false)
    setFetchingStats(false)
  }

  const submitDate = () => {
    // TODO: update in store when click apply
    updateSelectedDateInfo(statsDate)

    if (screenName === HOME) {
      hitTnxApi()
    }
    setShowModal(false)
    const isToday = statsDate?.dateLabel === 'Today'
    abortControllerRef?.current?.abort()
    abortControllerRef.current = new AbortController()
    fetchStatsApi(mid, 'transactions', statsDate, isToday, undefined, undefined, false, abortControllerRef.current)
  }

  const getFromToDateLabel = () => {
    const fromDate = new Date(selectedDateInfo?.fromDate)
    const toDate = new Date(selectedDateInfo?.toDate)
    let sameYear = fromDate?.getFullYear() === toDate?.getFullYear()
    let fromDateLabel, toDateLabel

    let labelPlaceholder = ''

    if (selectedDateInfo?.dateLabel === 'Today' || selectedDateInfo?.dateLabel === 'Yesterday') {
      labelPlaceholder = selectedDateInfo?.dateLabel
    } else if (selectedDateInfo?.dateLabel === 'Custom Range') {
      if (sameYear) {
        const year = toDate?.getFullYear()?.toString()?.slice(2, 4)
        fromDateLabel = `${roundOfToTwoDigits(fromDate?.getDate())} ${getMonthName[roundOfToTwoDigits(fromDate?.getMonth() + 1)]
          }'${year}`
        toDateLabel = `${roundOfToTwoDigits(toDate?.getDate())} ${getMonthName[roundOfToTwoDigits(toDate?.getMonth() + 1)]
          }'${year}`
      } else {
        fromDateLabel = `${roundOfToTwoDigits(fromDate?.getDate())} ${getMonthName[roundOfToTwoDigits(fromDate?.getMonth() + 1)]
          } ${fromDate?.getFullYear()?.toString()?.slice(2, 4)}`
        toDateLabel = `${roundOfToTwoDigits(toDate?.getDate())} ${getMonthName[roundOfToTwoDigits(toDate?.getMonth() + 1)]
          } ${toDate?.getFullYear()?.toString()?.slice(2, 4)}`
      }
      labelPlaceholder = `in (${fromDateLabel} - ${toDateLabel})`
    } else {
      labelPlaceholder = `in ${selectedDateInfo?.dateLabel?.toLowerCase()}`
    }
    return labelPlaceholder
  }

  // const calendar = selectedDateInfo
  const invalidDate = (calendar: any) => {
    if (calendar?.dateLabel !== 'Custom Range') {
      if (calendar?.fromDate && calendar?.toDate) {
        return false
      } else {
        return true
      }
    } else if (calendar?.dateLabel === 'Custom Range' && !calendar?.fromDate && !calendar?.toDate) {
      return true
    } else if (calendar?.dateLabel === 'Custom Range' && calendar?.fromDate && calendar?.toDate) {
      return false
    } else {
      return true
    }
  }

  return (
    <Box>
      <Box
        flexDirection={'row'}
        align="center"
        disabled={isFetchingStats}
        underlayColor={'TRANSPARENT'}
        testID="show-received"
        onPress={() => setShowModal(true)}>
        <Text fontFamily={'JioType-Medium'} letterSpacing={-0.07} fontSize={14} color="WHITE">
          {getString(selectedAppLanguage, 'received')} {getFromToDateLabel()}
        </Text>
        <Spacer size={5} direction="horizontal" />
        <Icon id="ARROW_DOWN" color={'WHITE'} size={17} />
      </Box>
      <ModBox height={45} show={isFetchingStats} alignItems="center" justify="center">
        <EmptyView
          onRetry={() => {
            onRefresh()
          }}
          isLoading={isFetchingStats}
          error={fetchStatsState === 'rejected'}
          loadingMessage=""
          emptyMessage=""
          loaderColor={'#fff' as ColorOptions}
        />
      </ModBox>
      <ModBox show={!isFetchingStats}>
        <Spacer size={5} direction="vertical" />
        <Text fontFamily={'JioType-Black'} fontSize={32} letterSpacing={-0.96} color="WHITE">
          {formatCurrency(successfulTxnsAmt) ?? 0}
        </Text>
      </ModBox>

      <ModalDialogNew
        onBackPress={() => setShowModal(false)}
        animate={true}
        type="bottom"
        show={showModal}
        backgroundColor={'TRANSPARENT'}>
        <Box borderTopLeftRadius={24} borderTopRightRadius={24} bg={'WHITE'} pt={30}>
          <Box
            pr={25}
            alignItems={'flex-end'}
            testID="close-received"
            onPress={handleClear}
            underlayColor={'TRANSPARENT'}>
            <SvgImage imageName="Close" />
          </Box>
          <Box overflow={'auto'}>
           <KeyboardAwareScrollView
              showsVerticalScrollIndicator={false}
              keyboardDismissMode="interactive"
              keyboardShouldPersistTaps={'handled'}
              scrollEnabled={true}
              enableAutomaticScroll={Platform.OS === 'ios'} 
              automaticallyAdjustKeyboardInsets={true}
              keyboardOpeningTime={Number.MAX_SAFE_INTEGER}
              enableResetScrollToCoords={false}
              extraHeight={120}
              enableOnAndroid={true}>
              <DateRangeSelector
                onDateRangeChange={handlePress}
                selectedDateInfo={selectedDateInfo}
                type={'EXPORT'}
                dateRange={receivedDateRange}
                selectedFilteredData={{ selectedDateInfo: selectedDateInfo }}
              />
              <Spacer size={8} direction="vertical" />
              <ModBox p={24} pt={0} w={'100%'}>
                <Button
                  disabled={isFetchingStats || disableBtn}
                  isFull
                  height={50}
                  isRound
                  testID="submit-date"
                  onPress={submitDate}
                  type={'primary'}
                  color={'PRIMARY'}
                  isLoading={isFetchingStats}
                  underlayColor="PRIMARY">
                  <Text fontFamily="JioType-Bold" fontSize={16} color="WHITE" lineHeight={24}>
                    {getString(selectedAppLanguage, 'apply')}
                  </Text>
                </Button>
              </ModBox>
            </KeyboardAwareScrollView>
          </Box>
        </Box>
      </ModalDialogNew>
    </Box>
  )
}
